import Mawar1 from '../../../Media/Greenwood/Cluster Flamboyan/Mawar/Mawar (1).png'
import Mawar2 from '../../../Media/Greenwood/Cluster Flamboyan/Mawar/Mawar (2).png'
import Mawar3 from '../../../Media/Greenwood/Cluster Flamboyan/Mawar/Mawar (3).png'


const Mawarimages =[
Mawar1, Mawar2, Mawar3
]

export default Mawarimages;